import { client } from '../api';
import { SUBSCRIPTIONS_URL } from './constants';

export const updateSubscription = async (id, subscription) =>
  await client.patch(`${SUBSCRIPTIONS_URL}${id}/`, subscription);

export const skipNextDelivery = async id =>
  await client.patch(`${SUBSCRIPTIONS_URL}${id}/skip_next_delivery/`, {});

export const reactivatePlan = async (id, couponCode) =>
  await client.put(
    `${SUBSCRIPTIONS_URL}${id}/activate/`,
    couponCode
      ? {
          coupon_code: couponCode,
        }
      : {},
  );
